import React from "react";
import { Box } from "@mui/material";

const PageLayout = ({ children }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        padding: "1rem",
      }}
    >
      {children}
    </Box>
  );
};

export default PageLayout;
